import type { PortMessage, UserProfile } from '@yoop/whitelabel-data';
import type { StateCreator } from 'zustand/vanilla';
import { createStore } from 'zustand/vanilla';

interface UserSlice {
  currentUser: UserProfile;
  updateCurrentUser: (user: UserProfile) => void;
}

const createUserSlice: StateCreator<UserSlice> = (set) => ({
  currentUser: undefined,
  updateCurrentUser: (newUser: UserProfile) => set({ currentUser: newUser }),
});

interface ConfigSlice {
  clientId: number;
  updateClient: (id: number) => void;
}

const createConfigSlice: StateCreator<ConfigSlice> = (set) => ({
  clientId: undefined,
  updateClient: (id) => set({ clientId: id }),
});

export const appStore = createStore<UserSlice & ConfigSlice>((...params) => ({
  ...createUserSlice(...params),
  ...createConfigSlice(...params),
}));

interface SendDataParams {
  action: string;
  key: string;
  getData: () => Promise<any>;
}
interface CommunicationStore {
  messageChannel: MessageChannel;
  sendMessage: (message: PortMessage) => void;
  sendDataMessage: (params: SendDataParams) => void;
}

export const communicationStore = createStore<CommunicationStore>((setState, getState) => ({
  messageChannel: new MessageChannel(),
  sendMessage: (message) => getState().messageChannel.port1.postMessage(message),
  sendDataMessage: async ({ action, key, getData }) => {
    let payload: PortMessage;
    try {
      const data = await getData();
      payload = {
        action,
        key,
        data: {
          success: true,
          result: data,
        },
      };
    } catch (error) {
      payload = {
        action,
        key,
        data: {
          success: false,
          error: error as any,
        },
      };
    } finally {
      getState().messageChannel.port1.postMessage(payload);
    }
  },
}));
